const polishMoney = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
})

const polishDateTime = new Intl.DateTimeFormat('pl-PL', {
  timeZone: 'Europe/Warsaw',
  dateStyle: 'medium',
  timeStyle: 'short',
})

/** Present backend minor units consistently as Polish zloty. */
export function formatBudgetAmount(amountMinorUnits: number | null): string {
  if (amountMinorUnits === null) return '—'
  return polishMoney.format(amountMinorUnits / 100)
}

/** Report timestamps are instants, displayed in the programme's Warsaw timezone. */
export function formatReportDateTime(value: string | null): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return polishDateTime.format(date)
}

/** Prefer the Polish snapshot label, but never hide a historical wire value. */
export function reportValueLabel(
  label: string | null | undefined,
  value: string | null | undefined,
): string {
  return label || value || '—'
}

export function reportFilterOptionLabel(option: { label: string; is_active: boolean }): string {
  return option.is_active ? option.label : `${option.label} (nieaktywna)`
}

export interface BudgetEntryReportFilters {
  search: string
  schoolId: string
  classId: string
  dateFrom: string
  dateTo: string
  kind: string
  incomeKind: string
  category: string
  classification: string
  emotion: string
}

/** Drops pagination so the list query params can be reused verbatim for the export request. */
export function omitPagination<T extends object>(params: T): Omit<T, 'page' | 'page_size'> {
  const rest = { ...params } as Record<string, unknown>
  delete rest.page
  delete rest.page_size
  return rest as Omit<T, 'page' | 'page_size'>
}

export function hasBudgetEntryReportFilters(
  filters: BudgetEntryReportFilters,
  emptyValue = '__all__',
): boolean {
  return (
    filters.search.trim() !== '' ||
    filters.schoolId !== emptyValue ||
    filters.classId !== emptyValue ||
    filters.dateFrom !== '' ||
    filters.dateTo !== '' ||
    filters.kind !== emptyValue ||
    filters.incomeKind !== emptyValue ||
    filters.category !== emptyValue ||
    filters.classification !== emptyValue ||
    filters.emotion !== emptyValue
  )
}
